module.exports = __webpack_public_path__ + "img/logos_customer_10.85ca6110.svg";